/* eslint-disable max-len */
const workflowTypes = [
  {
    id: 'privileged',
    name: 'Reportable Incident',
    shortName: 'Incident',
    description:
      'If any of the <a href="" class="reportable-conditions-link">reportable conditions</a> apply, a report must be completed and submitted to the Health and Safety Executive. Following the creation of an incident record, our specialist lawyers will contact you to advise you on how to do so and what else needs to be done. Don\'t worry, there\'ll be no bill for us to support you with this.',
    showContactInformation: true,
    showInfo: true,
  },
  {
    id: 'incident',
    reportableType: 'privileged',
    name: 'Non-reportable Incident',
    shortName: 'Incident',
    description:
      'If none of the <a href="" class="reportable-conditions-link">reportable conditions</a> apply, the incident is not reportable to the HSE but you should still record it and take the action you feel is appropriate.',
    showInfo: true,
  },
  {
    id: 'haulage_privileged',
    name: 'Reportable Incident',
    shortName: 'Incident',
    description:
      'If any of the <a href="" class="reportable-conditions-link">reportable conditions</a> apply, a report must be completed and submitted to the Health and Safety Executive. Following the creation of an incident record, our specialist lawyers will contact you to advise you on how to do so and what else needs to be done. Don\'t worry, there\'ll be no bill for us to support you with this.',
    showContactInformation: true,
    showInfo: true,
  },
  {
    id: 'haulage_incident',
    reportableType: 'haulage_privileged',
    name: 'Non-reportable Incident',
    shortName: 'Incident',
    description:
      'If none of the <a href="" class="reportable-conditions-link">reportable conditions</a> apply, the incident is not reportable to the HSE but you should still record it and take the action you feel is appropriate.',
    showInfo: true,
  },
  {
    id: 'observation',
    name: 'Observation',
    shortName: 'Observation',
    description: 'Potential risk or hazard reports',
  },
];
/* eslint-enable max-len */

export default {
  workflowTypes,
};
